import { FaInfoCircle, FaBullseye, FaEye, FaGem, FaUsers, FaHandHoldingUsd, FaClock, FaSmile } from 'react-icons/fa';

const About = () => {
  return (
    <div className="about-page">
      <h1><FaInfoCircle style={{ marginRight: '15px', color: 'var(--federal-blue)' }} /> About Us</h1>
      <p className="about-subtitle">Empowering financial dreams with innovative loan solutions</p>
      
      <section className="mission">
        <div className="section-icon"><FaBullseye /></div>
        <h2>Our Mission</h2>
        <p>
          To provide accessible and affordable loan solutions to individuals and businesses, 
          helping them achieve their financial goals with transparency, integrity, and cutting-edge technology. 
          We believe everyone deserves a chance to fulfill their dreams, and we're here to make that possible.
        </p>
      </section>
      
      <section className="vision">
        <div className="section-icon"><FaEye /></div>
        <h2>Our Vision</h2>
        <p>
          To become the most trusted financial partner by offering innovative loan products 
          with exceptional customer service and digital-first convenience. We envision a future 
          where financial assistance is just a click away, making dreams achievable for everyone.
        </p>
      </section>
      
      <section className="values">
        <div className="section-icon"><FaGem /></div>
        <h2>Our Core Values</h2>
        <ul>
          <li>Customer-Centric Approach - Your success is our priority</li>
          <li>Transparency in Operations - No hidden fees, clear terms</li>
          <li>Innovation in Solutions - Leveraging technology for better service</li>
          <li>Integrity in All Dealings - Honest, ethical business practices</li>
          <li>Speed & Efficiency - Quick approvals, faster disbursals</li>
          <li>Security & Trust - Your data and money are safe with us</li>
        </ul>
      </section>
      
      <section className="company-stats">
        <div className="stat-item">
          <div className="stat-icon"><FaUsers /></div>
          <div className="stat-number">10,000+</div>
          <div className="stat-label">Happy Customers</div>
        </div>
        <div className="stat-item">
          <div className="stat-icon"><FaHandHoldingUsd /></div>
          <div className="stat-number">₹500Cr+</div>
          <div className="stat-label">Loans Disbursed</div>
        </div>
        <div className="stat-item">
          <div className="stat-icon"><FaClock /></div>
          <div className="stat-number">72 hours</div>
          <div className="stat-label">Average Approval Time</div>
        </div>
        <div className="stat-item">
          <div className="stat-icon"><FaSmile /></div>
          <div className="stat-number">99.8%</div>
          <div className="stat-label">Customer Satisfaction</div>
        </div>
      </section>
    </div>
  );
};

export default About;